// @ts-strict-ignore
import { Component } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { ChannelAddress, CurrentData } from "src/app/shared/shared";
import { ModalComponent } from "../modal/modal";

@Component({
  selector: "Controller_Ess_ParallelPeakShavingAndSelfConsumption",
  templateUrl: "./flat.html",
  styleUrls: ["./flat.scss"],
})
export class FlatComponent extends AbstractFlatWidget {

  public peakShavingPowerChannelAddress: ChannelAddress;
  public rechargePowerChannelAddress: ChannelAddress;
  public minSocLimitChannelAddress: ChannelAddress;
  public multiUseStateLimitChannelAddress: ChannelAddress;

  public peakShavingPower: number;
  public rechargePower: number;
  public minSocLimit: number;
  public multiUseState: number;

  async presentModal() {
    const modal = await this.modalController.create({
      component: ModalComponent,
      componentProps: {
        component: this.component,
      },
    });
    return await modal.present();
  }

  protected override getChannelAddresses() {
    this.peakShavingPowerChannelAddress = new ChannelAddress(this.componentId, "_PropertyPeakShavingPower");
    this.rechargePowerChannelAddress = new ChannelAddress(this.componentId, "_PropertyMaxGridPowerDuringRecharge");
    this.minSocLimitChannelAddress = new ChannelAddress(this.componentId, "_PropertyMinSocLimit");
    this.multiUseStateLimitChannelAddress = new ChannelAddress(this.componentId, "MultiUseState");

    return [
      this.peakShavingPowerChannelAddress,
      this.rechargePowerChannelAddress,
      this.minSocLimitChannelAddress,
      this.multiUseStateLimitChannelAddress,
    ];
  }

  protected override onCurrentData(currentData: CurrentData) {
    this.peakShavingPower = currentData.allComponents[this.peakShavingPowerChannelAddress.toString()];
    this.rechargePower = currentData.allComponents[this.rechargePowerChannelAddress.toString()];
    this.minSocLimit = currentData.allComponents[this.minSocLimitChannelAddress.toString()];
    this.multiUseState = currentData.allComponents[this.multiUseStateLimitChannelAddress.toString()];
  }

  protected pinFormatter(value: number) {
    return `${value}%`;
  }

  protected isSelfConsumptionActive() : boolean {
    return this.multiUseState === 1;
  }
}
